import { scrollToId } from "../lib/scroll";

const LINKS = [
  { id: "heroes", label: "HEROES" },
  { id: "worlds", label: "WORLDS" },
  { id: "books", label: "BOOKS" },
  { id: "timeline", label: "TIMELINE" },
  { id: "upcoming", label: "UPCOMING" },
  { id: "trailer", label: "TRAILER" },
  { id: "creator", label: "CREATOR" },
  { id: "contact", label: "CONTACT" },
];

const Footer = () => (
  <footer data-testid="footer" className="relative z-10 border-t border-white/5 px-6 py-14 md:px-16 lg:px-24">
    <div className="flex flex-col gap-10 md:flex-row md:items-start md:justify-between">
      <div>
        <button
          data-testid="footer-logo"
          onClick={() => scrollToId("home")}
          className="transition-opacity duration-500 hover:opacity-80"
          aria-label="Cosmic Dreams — back to top"
        >
          <img
            src="/assets/cosmic-dreams-logo-hero.png"
            alt="COSMIC DREAMS — official logo"
            className="w-52 md:w-64"
          />
        </button>
        <p className="mt-4 font-mono text-[10px] tracking-[0.4em] text-[#D4AF37]/70 uppercase">
          Dream beyond reality.
        </p>
      </div>
      <nav className="flex flex-wrap gap-x-6 gap-y-2">
        {LINKS.map((l) => (
          <button
            key={l.id}
            data-testid={`footer-link-${l.id}`}
            onClick={() => scrollToId(l.id)}
            className="font-mono text-[10px] tracking-[0.25em] text-[#606070] transition-colors duration-500 hover:text-[#D4AF37]"
          >
            {l.label}
          </button>
        ))}
      </nav>
    </div>
    <div className="mt-12 flex flex-col gap-2 border-t border-white/5 pt-8 md:flex-row md:items-center md:justify-between">
      <p className="font-mono text-[9px] tracking-[0.3em] text-[#606070] uppercase">
        © 2026 Cosmic Dreams Universe · Created by Pandrangi Aditya Kiran
      </p>
      <p className="font-mono text-[9px] tracking-[0.3em] text-[#606070] uppercase">
        An original universe · All stories, characters and worlds are original works
      </p>
    </div>
  </footer>
);

export default Footer;
